export default __webpack_public_path__ + "static/test_2_3_ru-d8a2c998ddde6e73d866b3d1b48b1ffd.png";